import React from 'react';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { SplitButton } from 'primereact/splitbutton';
import { MenuItem } from 'primereact/menuitem';
import { Skeleton } from 'primereact/skeleton';
import { ReservationType } from '../../types/reservationType';

export const ReservationsHeader = ({
  reservationTypesLoading,
  uniqueReservationTypes,
  createButtonReservationType,
  onCreate,
  createButtonItems,
}: {
  reservationTypesLoading: boolean;
  uniqueReservationTypes: ReservationType[];
  createButtonReservationType: ReservationType | null;
  onCreate: () => void;
  createButtonItems: MenuItem[];
}) => {
  return (
    <div className='reservation-header'>
      <div className='header-left'>
        {!reservationTypesLoading &&
          uniqueReservationTypes &&
          (uniqueReservationTypes.length > 1 ? (
            <SplitButton
              label={`Nueva reserva de ${createButtonReservationType?.name ?? uniqueReservationTypes[0]?.name}`}
              outlined
              rounded
              onClick={onCreate}
              model={createButtonItems}
            />
          ) : uniqueReservationTypes.length === 1 ? (
            <Button
              label={`Nueva reserva de ${createButtonReservationType?.name ?? uniqueReservationTypes[0]?.name}`}
              outlined
              rounded
              onClick={onCreate}
              icon={PrimeIcons.PLUS}
            />
          ) : null)}
        {reservationTypesLoading && <Skeleton width='280px' height='40px' />}
      </div>
    </div>
  );
};
